var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGroup69(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 66,
    height: 63,
    viewBox: "0 0 66 63",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_129",
    "data-name": "Rectangle 129",
    width: 66,
    height: 63,
    transform: "translate(0 0)",
    fill: "#152d79",
    stroke: "#152d79",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_69",
    "data-name": "Group 69",
    transform: "translate(2.854 10.666)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_60",
    "data-name": "Group 60",
    transform: "translate(-2.854 -10.666)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M41.955,157.585a4.8,4.8,0,0,1-1.225-.158L3.563,147.473a4.851,4.851,0,0,1-3.4-5.889l4.69-17.479a1.2,1.2,0,1,1,2.322.62L2.489,142.2A2.439,2.439,0,0,0,4.2,145.154L41.347,155.1a2.393,2.393,0,0,0,2.925-1.692l1.877-6.956a1.2,1.2,0,0,1,2.322.625L46.6,154.026a4.8,4.8,0,0,1-4.642,3.56",
    transform: "translate(2.413 -97.333)",
    fill: "#152d79",
    stroke: "#152d79",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M107.264,38.457H68.807A4.812,4.812,0,0,1,64,33.65V4.807A4.812,4.812,0,0,1,68.807,0h38.457a4.812,4.812,0,0,1,4.807,4.807V33.65a4.812,4.812,0,0,1-4.807,4.807M68.807,2.4a2.408,2.408,0,0,0-2.4,2.4V33.65a2.408,2.408,0,0,0,2.4,2.4h38.457a2.408,2.408,0,0,0,2.4-2.4V4.807a2.408,2.408,0,0,0-2.4-2.4Z",
    transform: "translate(-51.967 7.373)",
    fill: "#152d79",
    stroke: "#152d79",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M116.807,57.614a4.807,4.807,0,1,1,4.807-4.807,4.812,4.812,0,0,1-4.807,4.807m0-7.211a2.4,2.4,0,1,0,2.4,2.4,2.408,2.408,0,0,0-2.4-2.4",
    transform: "translate(-92.756 -33.416)",
    fill: "#152d79",
    stroke: "#152d79",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M66.319,111.346a1.2,1.2,0,0,1-.851-2.05L76.82,97.944a3.7,3.7,0,0,1,5.1,0l3.379,3.379L94.652,90.1A3.61,3.61,0,0,1,97.4,88.8h.026a3.6,3.6,0,0,1,2.737,1.257l12.571,14.667a1.2,1.2,0,1,1-1.824,1.564L98.337,91.623a1.19,1.19,0,0,0-.914-.418,1.277,1.277,0,0,0-.923.432L86.3,103.874a1.2,1.2,0,0,1-.87.43,1.156,1.156,0,0,1-.9-.351l-4.31-4.309a1.235,1.235,0,0,0-1.7,0L67.167,111a1.2,1.2,0,0,1-.849.351",
    transform: "translate(-52.915 -68.088)",
    fill: "#152d79",
    stroke: "#152d79",
    strokeWidth: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup69);
export default __webpack_public_path__ + "static/media/Group69.e9217c458d1087bf3cf0d448f79e06cd.svg";
export { ForwardRef as ReactComponent };